import { requestBodyOf } from './menuRead'

/**
 * 单店下单被拒「Some Products Not Available」的 `error.info`（后端 `api/Services/Order/SoldOutEnvelope.php:45-55`）。
 * - 请求**没带** menuId：名字数组（今天的形状）；
 * - 请求**带了** menuId（单菜单店也算，requestedMenuId 在早退之前就记下了）：
 *   `{cartError:{<venueId>:[名字]}, cartErrorIds:{<venueId>:[venueProductId]}, menuFallback?:true}`；
 *   `menuFallback` 只在后端真的没认这份菜单时出现（回落主菜单）。
 *
 * 老站对这句今天只弹通用提示（`requestMixin.js` 的 `_createMessageDialog(error.message)`），**不**标红购物车行：
 * 标红只走 `##0##` 那条老错误码（`_addOrderErrorDialog`，按 id）。所以两种形状都归一成同一份结果、挂在错误上
 * 交给调用方，提示本身一字不变。`menuFallback` 这一批照普通售罄处理（只把标记带出来）；
 * 「菜单刚更新」弹窗与按 `cartErrorIds` 标红是 U-B6-2（owner D96）的事。
 *
 * @param {*} info error.info
 * @param {String} [venueId] 这次下单的门店；对象里没有这家店的键时把所有店的拼起来，不丢
 * @returns {{shape: 'names'|'keyed', names: String[], ids: String[], menuFallback: Boolean}|null}
 */
export function parseSoldOutEnvelope(info, venueId) {
  const strings = (list) => (Array.isArray(list) ? list.filter(item => typeof item === 'string') : [])
  if (Array.isArray(info)) {
    // 空数组不是售罄信封：commonFormResponse 的 info 默认就是 []（U-B6-1 review）
    const names = strings(info)
    return names.length ? { shape: 'names', names, ids: [], menuFallback: false } : null
  }
  if (!info || typeof info !== 'object' || !info.cartError || typeof info.cartError !== 'object' || Array.isArray(info.cartError)) {
    return null
  }
  const ids = info.cartErrorIds && typeof info.cartErrorIds === 'object' ? info.cartErrorIds : {}
  const pick = (byVenue) => {
    if (venueId && Object.prototype.hasOwnProperty.call(byVenue, venueId)) return strings(byVenue[venueId])
    return Object.keys(byVenue).reduce((all, key) => all.concat(strings(byVenue[key])), [])
  }
  return {
    shape: 'keyed',
    names: pick(info.cartError),
    ids: pick(ids),
    menuFallback: info.menuFallback === true
  }
}

const SINGLE_VENUE_ADD_ORDER = '/customer/default/add-order'

/**
 * 响应拦截器用：单店 add-order 的失败是不是售罄信封；是就归一，不是就 null。
 * 合单（add-venue-sub-group-order）这一轮不带菜单参数（D98①），不归这里。
 */
export function soldOutOfAddOrderFailure(url, error, requestData) {
  const path = typeof url === 'string' ? url.split('?')[0] : ''
  if (path !== SINGLE_VENUE_ADD_ORDER || !error || typeof error !== 'object') return null
  const body = requestBodyOf(requestData)
  const venueId = body && typeof body.venueId === 'string' ? body.venueId : ''
  return parseSoldOutEnvelope(error.info, venueId)
}
